import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  standalone: false,
  name: 'UserPhotoSanitizer',
})
export class UserPhotoSanitizerPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(value: string) {
    if (value !== null) {
      return this.sanitizer.bypassSecurityTrustUrl(value);
    }
    return value;
  }
}
